import { useStore } from "../../hooks-store/store";

const checkIfUserCan = (userRoles, requiredRoles) => {
  userRoles = userRoles ?? [];
  requiredRoles = requiredRoles ?? [];
  const testSet = new Set(requiredRoles);
  return userRoles.some((x) => testSet.has(x));
};

export const Can = ({ children, userRoles, requiredRoles }) => {
  if (userRoles) {
    if (checkIfUserCan(userRoles, requiredRoles)) {
      return children;
    }
  }
  return <div></div>;
};

export const AdminCan = ({ children }) => {
  const [store, _] = useStore();
  const userData = store.user;
  if (userData?.isAdmin) {
    return children;
  }
  return <></>;
};
